import { ICommentsItems } from 'redhotpie-shared-lib/models/comments';
import { PagingInfo } from 'redhotpie-shared-lib/models/pagingInfo';
interface ICommunityActionResponse {
  CommentCount: number;
  IsLiked: boolean;
  LikeCount: number;
}

interface IAlbumResponse {
  ApprovalState: string;
  ClubAlbumID: number;
  CommunityAction: ICommunityActionResponse;
  DateCreated: string;
  DateEdited: string;
  MediaCount: number;
  Title: string;
  Poster: {
    ClubID: number;
    Name: string;
    ClubBannerPhoto: {
      FullUrl: string;
      Width: number;
      Height: number;
      ApprovalState: string;
    };
    PrivacyType: 'Public' | 'Private';
    IsOwner: boolean;
  };
  SEOUrl: string;
  IsInteractable?: boolean | null;
}

interface IPoster {
  clubID: number;
  name: string;
  clubBannerPhoto: {
    fullUrl: string;
    width: number;
    height: number;
    approvalState: string;
  };
  privacyType: 'Public' | 'Private';
  isOwner: boolean;
}

interface ICommunityAction {
  commentCount: number;
  isLiked: boolean;
  likeCount: number;
}

export interface IAlbumDetail {
  approvalState: string;
  clubAlbumID: number;
  communityAction: ICommunityAction;
  dateCreated: string;
  mediaCount: number;
  title: string;
  seoUrl?: string;
}

export interface IAlbumDetailData extends AlbumDetail {
  paginationInfoComments: PagingInfo;
  comments: ICommentsItems[];
  isLoadingComments: boolean;
}

export default class AlbumDetail {
  approvalState: string;
  clubAlbumID: number;
  communityAction: ICommunityAction;
  dateCreated: string;
  dateEdited: string;
  mediaCount: number;
  title: string;
  poster: IPoster | null;
  seoUrl?: string;
  replyCount: number;
  likeCount: number;
  isMemberLike: boolean;
  isInteractable: boolean | null;

  constructor() {
    this.approvalState = '';
    this.clubAlbumID = -1;
    this.communityAction = {
      commentCount: 0,
      isLiked: false,
      likeCount: 0,
    };
    this.dateCreated = '';
    this.dateEdited = '';
    this.mediaCount = 0;
    this.title = '';
    this.poster = null;
    this.replyCount = 0;
    this.likeCount = 0;
    this.isMemberLike = false;
    this.isInteractable = null;
  }

  static mappingObject(_obj: IAlbumResponse): AlbumDetail {
    const obj = new AlbumDetail();

    obj.approvalState = _obj.ApprovalState || '';
    obj.clubAlbumID = _obj.ClubAlbumID || -1;
    obj.communityAction = {
      commentCount: _obj.CommunityAction?.CommentCount || 0,
      isLiked: _obj.CommunityAction?.IsLiked || false,
      likeCount: _obj.CommunityAction?.LikeCount || 0,
    };
    obj.dateCreated = _obj.DateCreated || '';
    obj.dateEdited = _obj.DateEdited || '';
    obj.mediaCount = _obj.MediaCount;
    obj.title = _obj.Title;
    obj.seoUrl = _obj.SEOUrl;

    obj.replyCount = obj.communityAction.commentCount;
    obj.likeCount = obj.communityAction.likeCount;
    obj.isMemberLike = obj.communityAction.isLiked;
    obj.isInteractable = _obj.IsInteractable || null;

    if (_obj.Poster) {
      obj.poster = {
        clubID: _obj.Poster.ClubID,
        name: _obj.Poster.Name,
        clubBannerPhoto: {
          fullUrl: _obj.Poster.ClubBannerPhoto.FullUrl,
          width: _obj.Poster.ClubBannerPhoto.Width,
          height: _obj.Poster.ClubBannerPhoto.Height,
          approvalState: _obj.Poster.ClubBannerPhoto.ApprovalState,
        },
        privacyType: _obj.Poster.PrivacyType,
        isOwner: _obj.Poster.IsOwner || false,
      };
    }

    //   {
    //     "ClubID": 1394,
    //     "Name": "TheSwingerCruise 123",
    //     "ClubBannerPhoto": {
    //         "FullUrl": "",
    //         "Width": 1280,
    //         "Height": 1280,
    //         "ApprovalState": "Pending"
    //     },
    //     "PrivacyType": "Private"
    // }

    return obj;
  }
}
